// Lightweight GA4 (gtag.js) event helper.
// The global `gtag` is defined in public/index.html and exposed on window.
// Guard against it being missing (ad blockers, dev) so tracking never throws.
export const trackEvent = (name, params = {}) => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
};
